import Link from "next/link";
import React from "react";
import cn from "classnames";
import { useRouter } from "next/router";
export default function Logo() {
  const router = useRouter();
  return (
    <Link
      href="/"
      className={cn("text-[26px] w-fit font-havletica font-normal text-left", {
        "text-white": router?.pathname !== "/media",
        "text-darkGrey": router?.pathname === "/media",
      })}
    >
      Chalk Studio
    </Link>
  );
}
